export default __webpack_public_path__ + "static/media/bundle-team.655233de.png";